export default __webpack_public_path__ + "static/media/Category-22.eda0a7fb.jpg";